import { render, staticRenderFns } from "./message-log.vue?vue&type=template&id=9281fecc&scoped=true&"
import script from "./message-log.vue?vue&type=script&lang=js&"
export * from "./message-log.vue?vue&type=script&lang=js&"
import style0 from "./message-log.vue?vue&type=style&index=0&id=9281fecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9281fecc",
  null
  
)

export default component.exports